import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { Box, Button, Paper, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';


export function FormCompletedPage() {
    const navigate = useNavigate();

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                mt: 10, // pushes it down without affecting footer
                mb: 10,
            }}
        >
            <Paper
                elevation={3}
                sx={{
                    p: { xs: 3, md: 4 },
                    textAlign: 'center',
                    borderRadius: 3,
                    maxWidth: 500,
                }}
            >
                <Box sx={{ mb: 2 }}>
                    <CheckCircleOutlineIcon
                        sx={{
                            fontSize: 64,
                            color: (theme) => theme.palette.success.main,
                        }}
                    />
                </Box>

                <Typography variant="h4" component="h1" gutterBottom>
                    {/* Title here */}
                </Typography>

                <Typography
                    variant="body1"
                    sx={{
                        mb: 4,
                        color: (theme) => theme.palette.text.secondary,
                    }}
                >
                    Thank you for your booking request. Processing may take up to five
                    working days.
                </Typography>

                <Button
                    variant="contained"
                    color="info"
                    size="large"
                    onClick={() => navigate("/Forms")}
                >
                    Create new booking
                </Button>
            </Paper>
        </Box>



    );
};

